import { Trans } from '@lingui/macro';
import React, { FC } from 'react';

import ActivityFeed from 'Components/ActivityFeed/ActivityFeed.async';
import AndroidBanner from 'Components/AndroidBanner/AndroidBanner';
import Feedbacks from 'Components/Feedbacks/Feedbacks';
import WizardLocationSticky from 'Components/WizardLocationSticky/WizardLocationSticky.async';
import 'common/styles/SlickSlider.scss';
import { Heading3 } from 'uikit/Heading';

import L4Benefits from './L4Benefits/L4Benefits';
import { L4CategoryTopSectionProps } from './L4Category.helpers';
import './L4Category.scss';
import L4CityDistrictsText from './L4CityDistrictsText';
import L4Header from './L4Header/L4Header';

const L4CategoryTopSection: FC<L4CategoryTopSectionProps> = (props) => {
  const { l4BySlug, cityBySlug, neighbourhood } = props;

  const {
    id: l4Id,
    name,
    slug,
    coverUrl,
    mobileCoverUrl,
    isNew,
    l2,
    providerCount,
    avgResponseTime,
    feedbacks,
    feedbacksInfo,
    medianPrice,
  } = l4BySlug;

  const nameLocativeCase: string = cityBySlug?.nameLocativeCase || '';
  const cityName: string = cityBySlug?.name || '';
  const feedbacksLength: number = Array.isArray(feedbacks) ? feedbacks.length : 0;

  return (
    <div className="l4Category__topSections">
      <AndroidBanner />
      <div className="l4Category__header">
        <L4Header
          l4Id={l4Id}
          name={name}
          coverUrl={coverUrl}
          mobileCoverUrl={mobileCoverUrl}
          l2Name={l2.name}
          l2Slug={l2.slug}
          l2Id={l2.id}
          nameLocativeCase={nameLocativeCase || cityName}
          cityName={cityName}
          isNew={isNew}
          citySlug={cityBySlug ? cityBySlug.slug : null}
          neighbourhoodName={neighbourhood?.name || ''}
        />
      </div>
      <div className="l4Category__sectionTop">
        <div className="l4Category__search">
          <WizardLocationSticky
            key={`${slug}.${cityBySlug ? cityBySlug.slug : ''}`}
            city={cityBySlug}
            neighbourhood={neighbourhood}
          />
        </div>
        <div className="l4Category__benefitsFeed">
          <div className="l4Category__benefits">
            <L4Benefits
              providersCount={providerCount}
              responseTime={avgResponseTime}
              noProviders={isNew}
              averageFeedbacksValue={feedbacksInfo.averageValue}
              feedbacksCount={feedbacksInfo.count}
              l2Slug={l2.slug}
              price={medianPrice}
            />
          </div>
          <div className="l4Category__feed">
            <div className="l4Category__feedFixed">
              <div className="l4Category__subtitle l4Category__subtitle_feed">
                <Heading3 as="div">
                  <Trans>Aktualności</Trans>
                </Heading3>
              </div>
              <ActivityFeed
                /* @ts-expect-error type mismatch */
                l2Slug={l2.slug}
                hideAvatarsDesktop
                withGreyBackground
                desktopShortVersion={feedbacksLength < 2}
              />
            </div>
          </div>
        </div>

        {feedbacksLength > 0 && (
          <div className="l4Category__feedbacks">
            <div className="l4Category__feedbacksWrap">
              <div className="l4Category__subtitle">
                <Heading3 as="div">
                  <Trans>Jak wykonawców oceniają inni użytkownicy Fixly?</Trans>
                </Heading3>
              </div>
              <Feedbacks
                feedbacks={feedbacks}
                type="block"
                isExpandable
                showProvider
                allowVisuallyHidden
                disableProfileLinks
                l4Name={cityBySlug ? l4BySlug.name : undefined}
                city={cityName}
              />
            </div>
          </div>
        )}

        {cityBySlug?.hasCityDistricts && (
          <div className="l4Category__districts">
            <L4CityDistrictsText cityId={cityBySlug.id} l4Name={name} />
          </div>
        )}
      </div>
    </div>
  );
};

export default L4CategoryTopSection;
